import type { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { Fragment } from 'react';
import Icon, { IconName } from '../../icon/Icon';
import { useStyles } from './Button.styles';
import {
  ButtonIconPosition,
  type ButtonProps,
  ButtonSize,
  ButtonVariant,
} from './types';

export function isIconOnly(args: {
  children?: React.ReactNode;
  iconName?: IconName;
}) {
  return !args.children && Boolean(args.iconName);
}

export function getOverrides(props: ButtonProps): Partial<MuiButtonProps> {
  const { classes, cx } = useStyles({
    size: props.size ?? ButtonSize.MD,
  });

  const overrides: Partial<MuiButtonProps> = {
    className: cx(classes.root, props.className),
    loading: props.isLoading,
    variant: props.variant,
  };

  const supportsIcons = props.variant !== ButtonVariant.INLINE;

  if (supportsIcons && props.iconName) {
    if (props.iconPosition === ButtonIconPosition.RIGHT) {
      overrides.endIcon = <Icon name={props.iconName} />;
    } else {
      overrides.startIcon = <Icon name={props.iconName} />;
    }
  }

  if (supportsIcons && props.externalLink) {
    overrides.endIcon = <Icon name={IconName.EXTERNAL_LINK} />;
  }

  if (props.isLoading) {
    overrides.loadingIndicator = <Fragment />;
    if (supportsIcons) {
      overrides.endIcon = (
        <Icon name={IconName.LOADING_RING} classname={classes.loadingIcon} />
      );
    }
  }

  return overrides;
}
